import { api } from '@api'
import { FetchParams, PaginatedResponse } from './types'
import { usePaginate } from './usePaginate'
import { Scope } from '@utils'

export type Note = {
  id: string
  title?: string
  content: string
  createdByAccountId: string
  contactAccountId: string | null // null for personal notes, accountId for shared notes
  scope: string
  isShared: boolean
  createdAt: string
  updatedAt: string
}

const fetchNotes = async ({ pageParam = '0', q, contactId, scope, type }: FetchParams): Promise<PaginatedResponse<Note>> => {
  let url = `/notes?page=${pageParam}`
  if (q) url += `&q=${q}`
  if (contactId) url += `&contactId=${contactId}`
  if (scope) url += `&scope=${scope}`
  if (type) url += `&type=${type}` // 'personal' or 'shared'
  
  const { data } = await api.get<PaginatedResponse<Note>>(url)
  return data
}

export const usePaginateNotes = ({q, contactId, scope, type}: {q?: string, contactId?: string, scope?: Scope, type?: 'personal' | 'shared'}) => {
  return usePaginate<Note>('notes', fetchNotes, { q, contactId, scope, type })
}

